import {Injectable} from '@angular/core';
import * as moment from 'moment';
import {File, FileEntry} from '@ionic-native/file';
import {TranslateService} from '@ngx-translate/core';
import {PermissionCheckProvider} from '../../../providers/permission-check/permission-check';
import {ReportProblemsApi} from '../../../shared/nestjs/gd-all-in-one/services/report-problems.api';
import {Observable} from 'rxjs';
import {
  MasterProblemCategoryData,
  RequestCreateTicketDto,
  ResponseCreateTicketDto,
  ResponseMasterProblemCategoryDto,
} from '../../../shared/nestjs/gd-all-in-one/dto/report-problems.dto';
import {Storage} from '@ionic/storage';

@Injectable()
export class UserFeedbackBloc {
  constructor(
      private translate: TranslateService,
      private permissionCheckProvider: PermissionCheckProvider,
      private reportProblemsApi: ReportProblemsApi,
      private storage: Storage,
      private file: File,
  ) {
  }

  processWebFile(event): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      const name = event.target.files[0].name;
      const fileIMG = ['png', 'jpg', 'jpeg', 'bmp', 'gif'];
      const formatImage = name.split('.').pop();
      const res = formatImage.toLowerCase();
      const options = moment().valueOf() + '.jpg';

      if (fileIMG.indexOf(res) < 0) {
        reject('File type is invalid');
      } else {
        const size = event.target.files[0].size;
        if (size > 10000000) {
          reject(this.translate.instant('File Size Maximum 10MB'));
        } else {
          let base: any;
          const reader = new FileReader();
          reader.addEventListener('load', () => {
            base = reader.result;
            resolve({
              data: base,
              options: options,
              isSelected: false,
              eventsWebview: <Array<File>>event.target.files[0],
              type: 'image',
            });
          }, false);
          reader.readAsDataURL(event.target.files[0]);
        }
      }
    })
  }

  async takePictureMobile(isCamera: boolean): Promise<any> {
    try {
      const imageData = await this.permissionCheckProvider.getCamera({
        quality: 50,
        sourceType: isCamera,
        allowEdit: false,
        targetWidth: 600,
        targetHeight: 600,
        cameraDirection: 0
      });

      const options = {
        fileKey: 'file',
        fileName: moment().valueOf() + '.jpg',
        chunkedMode: false,
        mimeType: 'image/jpg'
      };

      return Promise.resolve({
        data: imageData,
        options: options,
        isSelected: true,
        eventsWebview: '',
        type: 'image',
      })
    } catch (e) {
      return Promise.reject(e);
    }
  }

  async getMasterProblemCategory(host: string): Promise<Observable<ResponseMasterProblemCategoryDto>> {
    const storage = await this.getSFGoAuth();
    if (storage && storage.id) return this.reportProblemsApi.masterProblemCategory();
    return this.reportProblemsApi.masterProblemCategoryWithoutToken(host);
  }

  async getSFGoAuth(): Promise<any> {
    return JSON.parse(await this.storage.get('SFGoAuth'));
  }

  async createTicket(payload: RequestCreateTicketDto, host: string): Promise<Observable<ResponseCreateTicketDto>> {
    const storage = await this.getSFGoAuth();
    if (storage && storage.id) return this.reportProblemsApi.createTicket(payload);
    return this.reportProblemsApi.createTicketWithoutToken(payload, host);
  }

  processFile(imageFileUri: any): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      this.file.resolveLocalFilesystemUrl(imageFileUri)
          .then(entry => (<FileEntry>entry).file(async file => {
            const blob = await this.readFile(file);
            resolve(blob);
          }))
          .catch(err => {
                console.log(err);
                reject(err);
              }
          );
    })
  }

  readFile(file: any): Promise<any> {
    return new Promise<any>(resolve => {
      const reader = new FileReader();
      reader.onloadend = () => {
        const imgBlob = new Blob([reader.result], {type: file.type});
        resolve(imgBlob);
      };
      reader.readAsArrayBuffer(file);
    })
  }

  saveToStorage(data: MasterProblemCategoryData[]): Promise<void> {
    return this.storage.set('problemCategory', JSON.stringify(data));
  }

  async getFromStorage(): Promise<MasterProblemCategoryData[]> {
    const problemCategory = await this.storage.get('problemCategory');
    if (problemCategory) {
      return JSON.parse(problemCategory);
    } else {
      return problemCategory;
    }
  }

  masterProblem(): MasterProblemCategoryData[] {
    return [
      {
        id: 2,
        categoryCode: 'DBC',
        categoryName: 'database connection',
        createdAt: '2020-02-07T13:59:03.000Z',
      },
      {
        id: 3,
        categoryCode: 'APV',
        categoryName: 'app version',
        createdAt: '2020-02-07T13:59:38.000Z',
      },
      {
        id: 4,
        categoryCode: 'ATT',
        categoryName: 'attendance',
        createdAt: '2020-02-07T14:00:57.000Z',
      },
      {
        id: 5,
        categoryCode: 'PAY',
        categoryName: 'payroll',
        createdAt: '2020-02-07T14:01:28.000Z',
      },
      {
        id: 6,
        categoryCode: 'CON',
        categoryName: 'connection',
        createdAt: '2020-02-21T10:53:24.000Z',
      }
    ];
  }
}



// WEBPACK FOOTER //
// ./src/bloc/feature/user-feedback/user-feedback.bloc.ts